export enum eventTypeEnum {
  surgery = 'surgery',
  medical_device_adjustment = 'medical_device_adjustment',
  fall = 'fall',
}

export interface IDiagnosisOption {
  code: string;
  description: string;
  title?: string;
}

export interface ISurgeryOption {
  id: number;
  name: string;
  eventDate: string;
  patientUuid?: string;
  other?: string;
}

export interface IFallOption {
  icd?: string;
  description?: string;
  dateOfFall: string;
  patientUuid: string;
  location?: string;
  witnessed?: boolean | null | string;
  createdAt?: string;
  reporterUserUuid?: string;
  uuid: string;
}

export interface IMedicalDeviceAdjustment {
  uuid?: string;
  timestamp: string;
  description: string;
  medicalDeviceName?: string | number | null;
  patientUuid?: string;
  timezone_date?: string;
  timezone_time?: string;
}

export interface IPatientFeatureTags {
  orthotic_flow?: boolean;
  prosthetic_flow?: boolean;
}
export interface IClinicalInfo {
  height: number;
  weight: number;
  inch?: number;
  assistiveDevice: string;
  /**
   * @deprecated for post
   */
  icd10: IDiagnosisOption[];
  assistanceLvl: string;
  surgeries: ISurgeryOption[];
  /**
   * @deprecated we don't use it
   */
  allowedActions: string[];
  /**
   * @deprecated for post
   */
  medicalDeviceAdjustments: IMedicalDeviceAdjustment[];
  externalEmrId?: string;
  nonAmbulatory?: boolean;
  kLevel: number | null;
  falls: IFallOption[];
  patientFeatureTags?: IPatientFeatureTags;
  mrn?: string;
}

export interface IEventList {
  refDate: string;
  id: string;
  eventType: string;
  title: string;
  description: string;
  questionnaireName: string;
  medicalDeviceType: string;
  timestamp?: string;
  locale?: string;
}
